import { useContext } from 'react';
import { ThemeModeContext, type ThemeModeContextValue } from './themeModeContext';

/**
 * Access the theme-mode context. Throws if used outside an
 * <AppThemeProvider/> — always a programming error we want to surface
 * loudly in tests. Mirrors `shared/auth/useAuth.ts`.
 */
export const useThemeMode = (): ThemeModeContextValue => {
  const ctx = useContext(ThemeModeContext);
  if (!ctx) {
    throw new Error('useThemeMode must be used within <AppThemeProvider/>');
  }
  return ctx;
};
